import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-edit-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 25 25"
      fill="none"
      [attr.aria-hidden]="decorative ? 'true' : null"
      [attr.role]="decorative ? null : 'img'"
      [attr.aria-label]="decorative ? null : ariaLabel"
      class="edit-icon"
    >
      <path d="M18.4894 7.29199L14.5832 3.38574L4.1665 13.8024V17.7087H8.07275L18.4894 7.29199ZM21.5675 4.21387C21.9738 3.80762 21.9738 3.14616 21.5675 2.73991L19.1353 0.307617C18.729 -0.0986328 18.0675 -0.0986328 17.6613 0.307617L15.6248 2.34408L19.5311 6.25033L21.5675 4.21387Z" fill="currentColor"/>
      <path d="M0 20.833H25V24.9997H0V20.833Z" fill="currentColor" opacity="0.36"/>
    </svg>
  `,
  styles: [
    `
      .edit-icon {
        display: inline-block;
        vertical-align: middle;
      }
    `
  ]
})
export class EditIconComponent {
  @Input() size = 25;
  @Input() decorative = true;
  @Input() ariaLabel = 'Edit';
}
